import React from 'react'

import { Icon } from '@iconify/react'
import mailOpenFill from '@iconify/icons-ri/mail-open-fill'
import fileCopy2Fill from '@iconify/icons-ri/file-copy-2-fill'
import virusFill from '@iconify/icons-ri/virus-fill'

import useResponsive from '../hooks/useResponsive'

export default () => {

  const { isFullhd, isMobileText } = useResponsive()

  return (
    <div className="jobSearch">
      <h2 className="jobSearch__title title is-3">Je cherche ...</h2>
      <p
        className={"jobSearch__text content "
        + (isMobileText ? "is-medium" : "")}>
        Un poste de développeur web dans une agence créative&nbsp;! Une partie motion / creative coding serait un plus indéniable&nbsp;!
      </p>
      <p
        className={"jobSearch__text content "
        + (isMobileText ? "is-medium" : "")}>
        <Icon icon={virusFill} width={48} />
        En cette période de crise sanitaire, le gouvernement français <a className="about__textLink glitch-link" rel="noreferrer" target="_blank" href="https://www.gouvernement.fr/info-coronavirus/retour-au-travail" data-text="recommande">recommande</a> 2 à 3 jours par semaine télétravaillés, un effort difficile pour employeurs et salariés.<br />
        Cependant mes connaissances en biologie me poussent à prendre au sérieux cette recommandation, j'aimerais donc autant que possible la respecter par soucis de préservation et de respect de mes collègues, de moi même, ainsi que de la société dans son ensemble.<br />
        Si le sujet du télétravail vous inquiète, n'hésitez pas à lire ce <a className="about__textLink glitch-link" data-text="très bon article" rel="noreferrer" target="_blank" href="https://theconversation.com/pourquoi-travaille-t-on-plus-et-mieux-en-teletravail-148131">très bon article</a>.
      </p>
      <div className="jobSearch__field field has-addons">
        <p className="control">
          <input className={"input jobSearch__input " + (isFullhd ? 'is-medium' : '')} type="text" placeholder="leodsp@protonmail.com" disabled />
        </p>
        <p className="control">
          <button
            className="button jobSearch__button is-medium"
            data-tooltip="Copier mon adresse email"
            onClick={() => {navigator.clipboard.writeText('leodsp@protonmail.com')}}
          >
            <Icon icon={fileCopy2Fill} width={24} />
          </button>
        </p>
        <p className="control">
          <a
            className="button jobSearch__button is-medium"
            href="mailto:leodsp@protonmail.com"
            data-tooltip="M'envoyer un email"
          >
            <Icon icon={mailOpenFill} width={24} />
          </a>
        </p>
      </div>
    </div>
  )
}